import {useRef} from "react";
import {useMeDataContext} from "../../../providers/MeProvider";
import {
	rememberManualVisit,
	scopeFromCompanyEmployee,
	scopeFromLaunch,
	TakeoffsVersion,
	versionSwitchUrl,
	writeChosenVersion,
} from "../../../utils/takeoffsVersion";

/**
 * Opens another version now and remembers it for this user, so the next Utilities visit marks it.
 * manualView=1 keeps that visit on the version they picked.
 */
export function useSwitchVersion() {
	const {user} = useMeDataContext();
	const leaving = useRef(false);

	return (version: TakeoffsVersion) => {
		if (leaving.current) return;
		leaving.current = true;
		const scope = scopeFromCompanyEmployee(user?.companyId, user?.simproUserId)
			?? scopeFromLaunch(window.location.search);
		writeChosenVersion(scope, version);
		rememberManualVisit(version);
		window.location.href = versionSwitchUrl(version, window.location.search);
		// Re-arm in the next task so a navigation cancelled by a beforeunload prompt doesn't leave the button dead.
		setTimeout(() => {
			leaving.current = false;
		}, 0);
	};
}
